// extracted by mini-css-extract-plugin
module.exports = {"imgSidebar":"Sidebar_imgSidebar__3kfaa"};